(function () {
  'use strict';

  var BUTTON_SELECTOR = [
    '.button',
    '.shopify-challenge__button',
    '.customer button',
    '[data-button-animation="invert"]',
  ].join(',');

  /*
   * Buttons that already have their own specialized animation.
   */
  var SKIP_SELECTOR = [
    '[data-button-animation="off"]',
    '.button--tertiary',
    '.button-label',
    '.visually-hidden',
    '.product__xr-button',
    '.product-sticky-atc__submit',
    '.product-related-quick-add__submit',
    '.cart-drawer-recommendations__submit',
  ].join(',');

  var SPECIAL_LOADING_SELECTOR = [
    '.product-form__adding-text',
    '.product-sticky-atc__adding-text',
  ].join(',');

  var LOADING_CLASS =
    'magnaear-button--loading';

  var MOTION_CLASS =
    'magnaear-button-motion';

  var PRESSED_CLASS =
    'magnaear-button--pressed';

  var FALLBACK_DURATION = 15000;
  var TOUCH_RELEASE_DELAY = 240;
  var MOBILE_CHECKOUT_DELAY = 700;

  function isElement(node) {
    return node && node.nodeType === 1;
  }

  function isSpecializedButton(button) {
    if (!button || !button.matches) {
      return true;
    }

    if (button.matches(SKIP_SELECTOR)) {
      return true;
    }

    if (
      button.querySelector &&
      button.querySelector(
        SPECIAL_LOADING_SELECTOR
      )
    ) {
      return true;
    }

    return Boolean(
      button.matches(
        '.product-form__submit'
      ) &&
      button.closest(
        '.product--reference-gallery'
      )
    );
  }

  function isEligibleButton(button) {
    return Boolean(
      button &&
      button.matches &&
      button.matches(
        BUTTON_SELECTOR
      ) &&
      !isSpecializedButton(button)
    );
  }

  function getForm(
    button,
    suppliedForm
  ) {
    if (suppliedForm) {
      return suppliedForm;
    }

    if (button.form) {
      return button.form;
    }

    return button.closest
      ? button.closest('form')
      : null;
  }

  function getButtonText(button) {
    if (!button) return '';

    if (button.tagName === 'INPUT') {
      return String(
        button.value || ''
      )
        .replace(/\s+/g, ' ')
        .trim();
    }

    return String(
      button.textContent || ''
    )
      .replace(/\s+/g, ' ')
      .trim();
  }

  /*
   * Select loading text according to the button's purpose.
   */
  function inferLoadingText(
    button,
    suppliedForm
  ) {
    if (
      !button ||
      isSpecializedButton(button)
    ) {
      return '';
    }

    if (
      button.hasAttribute(
        'data-loading-text'
      )
    ) {
      return String(
        button.getAttribute(
          'data-loading-text'
        ) || ''
      ).trim();
    }

    var form = getForm(
      button,
      suppliedForm
    );

    var name = String(
      button.getAttribute('name') || ''
    ).toLowerCase();

    var id = String(
      button.id || ''
    ).toLowerCase();

    var className = String(
      button.className || ''
    ).toLowerCase();

    var formId = form
      ? String(form.id || '').toLowerCase()
      : '';

    var formClass = form
      ? String(form.className || '').toLowerCase()
      : '';

    var action = form
      ? String(
          form.getAttribute('action') || ''
        ).toLowerCase()
      : '';

    var formKey = [
      formId,
      formClass,
      action,
    ].join(' ');

    if (
      button.hasAttribute(
        'data-product-url'
      )
    ) {
      return 'LOADING OPTIONS';
    }

    if (
      name === 'add' ||
      className.indexOf(
        'product-form__submit'
      ) !== -1 ||
      action.indexOf(
        '/cart/add'
      ) !== -1
    ) {
      return 'ADDING ITEM';
    }

    if (
      name === 'checkout' ||
      id === 'checkout' ||
      className.indexOf(
        'checkout-button'
      ) !== -1
    ) {
      return 'מעבד את ההזמנה';
    }

    if (
      formKey.indexOf(
        'newsletter'
      ) !== -1 ||
      formKey.indexOf(
        'email-signup'
      ) !== -1
    ) {
      return 'SUBSCRIBING';
    }

    if (
      formKey.indexOf(
        'contactform'
      ) !== -1 ||
      formKey.indexOf(
        'contact-form'
      ) !== -1 ||
      formKey.indexOf(
        'contact__form'
      ) !== -1
    ) {
      return 'SENDING';
    }

    if (
      formKey.indexOf(
        'customer_login'
      ) !== -1 ||
      action.indexOf(
        '/account/login'
      ) !== -1
    ) {
      return 'SIGNING IN';
    }

    if (
      formKey.indexOf(
        'create_customer'
      ) !== -1 ||
      formKey.indexOf(
        'create-customer'
      ) !== -1
    ) {
      return 'CREATING ACCOUNT';
    }

    if (
      formKey.indexOf(
        'recover_customer_password'
      ) !== -1 ||
      formKey.indexOf(
        'recover-password'
      ) !== -1 ||
      action.indexOf(
        '/account/recover'
      ) !== -1
    ) {
      return 'SENDING';
    }

    if (
      formKey.indexOf(
        'customer_address'
      ) !== -1 ||
      action.indexOf(
        '/account/addresses'
      ) !== -1
    ) {
      return 'SAVING';
    }

    if (
      formKey.indexOf(
        'commentform'
      ) !== -1 ||
      formKey.indexOf(
        'article-comment'
      ) !== -1 ||
      action.indexOf(
        '/comments'
      ) !== -1
    ) {
      return 'POSTING';
    }

    if (
      formKey.indexOf(
        'storefront_password'
      ) !== -1 ||
      action.indexOf(
        '/password'
      ) !== -1
    ) {
      return 'ENTERING';
    }

    if (
      formKey.indexOf(
        'search'
      ) !== -1 ||
      action.indexOf(
        '/search'
      ) !== -1
    ) {
      return 'SEARCHING';
    }

    if (
      form &&
      String(
        form.method || ''
      ).toLowerCase() === 'post'
    ) {
      return 'PROCESSING';
    }

    return '';
  }

  function isCheckoutButton(button) {
    if (!button) return false;

    var name = String(
      button.getAttribute('name') || ''
    ).toLowerCase();

    var id = String(
      button.id || ''
    ).toLowerCase();

    var className = String(
      button.className || ''
    ).toLowerCase();

    return Boolean(
      name === 'checkout' ||
      id === 'checkout' ||
      className.indexOf(
        'checkout-button'
      ) !== -1
    );
  }

  function isTouchLayout() {
    return Boolean(
      window.matchMedia &&
      window.matchMedia(
        '(hover: none), (pointer: coarse)'
      ).matches
    );
  }

  function ensureLoadingMarkup(
    button,
    loadingText
  ) {
    if (
      !loadingText ||
      button.tagName === 'INPUT' ||
      !getButtonText(button)
    ) {
      return null;
    }

    var wrapper =
      button.querySelector(
        '.magnaear-button__loading-text'
      );

    var word;

    if (!wrapper) {
      wrapper =
        document.createElement('span');

      wrapper.className =
        'magnaear-button__loading-text';

      wrapper.setAttribute(
        'aria-hidden',
        'true'
      );

      word =
        document.createElement('span');

      word.className =
        'magnaear-button__loading-word';

      var dots =
        document.createElement('span');

      dots.className =
        'magnaear-button__loading-dots';

      for (
        var index = 0;
        index < 3;
        index += 1
      ) {
        var dot =
          document.createElement('span');

        dot.textContent = '.';
        dots.appendChild(dot);
      }

      wrapper.appendChild(word);
      wrapper.appendChild(dots);
      button.appendChild(wrapper);
    } else {
      word =
        wrapper.querySelector(
          '.magnaear-button__loading-word'
        );
    }

    if (!word) return null;

    var isRtlLoadingText =
      /[\u0590-\u05ff]/.test(
        loadingText
      );

    wrapper.setAttribute(
      'dir',
      isRtlLoadingText ? 'rtl' : 'ltr'
    );

    wrapper.classList.toggle(
      'magnaear-button__loading-text--rtl',
      isRtlLoadingText
    );

    word.setAttribute(
      'dir',
      isRtlLoadingText ? 'rtl' : 'ltr'
    );

    word.textContent =
      loadingText;

    button.style.setProperty(
      '--magnaear-loading-steps',
      String(
        Math.max(
          1,
          loadingText
            .replace(/\s+/g, '')
            .length
        )
      )
    );

    return wrapper;
  }

  function prepareButton(button) {
    if (!isEligibleButton(button)) {
      return;
    }

    if (
      !button.classList.contains(
        MOTION_CLASS
      )
    ) {
      button.classList.add(
        MOTION_CLASS
      );
    }
  }

  function prepareTree(root) {
    if (!isElement(root)) return;

    if (
      root.matches &&
      root.matches(
        BUTTON_SELECTOR
      )
    ) {
      prepareButton(root);
    }

    if (root.querySelectorAll) {
      root
        .querySelectorAll(
          BUTTON_SELECTOR
        )
        .forEach(prepareButton);
    }
  }

  function stopFallback(button) {
    if (
      !button._magnaearLoadingTimer
    ) {
      return;
    }

    window.clearTimeout(
      button._magnaearLoadingTimer
    );

    button._magnaearLoadingTimer =
      null;
  }

  /*
   * Touch interaction handling.
   */
  function stopPressRelease(button) {
    if (
      !button ||
      !button._magnaearPressTimer
    ) {
      return;
    }

    window.clearTimeout(
      button._magnaearPressTimer
    );

    button._magnaearPressTimer =
      null;
  }

  function clearPressed(button) {
    if (!button) return;

    stopPressRelease(button);

    if (
      button.classList.contains(
        PRESSED_CLASS
      )
    ) {
      button.classList.remove(
        PRESSED_CLASS
      );
    }

    delete button
      ._magnaearPointerId;
  }

  function canPress(button) {
    return Boolean(
      isEligibleButton(button) &&
      !button.disabled &&
      button.getAttribute(
        'aria-disabled'
      ) !== 'true' &&
      !button.classList.contains(
        LOADING_CLASS
      )
    );
  }

  function findEventButton(target) {
    if (
      !target ||
      !target.closest
    ) {
      return null;
    }

    var button = target.closest(
      BUTTON_SELECTOR
    );

    return canPress(button)
      ? button
      : null;
  }

  function beginTouchPress(
    button,
    pointerId
  ) {
    if (!canPress(button)) return;

    stopPressRelease(button);

    button._magnaearPointerId =
      pointerId;

    button.classList.add(
      PRESSED_CLASS
    );
  }

  function releaseTouchPress(
    button,
    immediate
  ) {
    if (!button) return;

    stopPressRelease(button);

    if (
      immediate ||
      button.classList.contains(
        LOADING_CLASS
      )
    ) {
      clearPressed(button);
      return;
    }

    button._magnaearPressTimer =
      window.setTimeout(
        function () {
          clearPressed(button);
        },
        TOUCH_RELEASE_DELAY
      );
  }

  function releasePressedForPointer(
    pointerId,
    immediate
  ) {
    document
      .querySelectorAll(
        '.' + PRESSED_CLASS
      )
      .forEach(function (button) {
        if (
          button._magnaearPointerId ===
          pointerId
        ) {
          releaseTouchPress(
            button,
            immediate
          );
        }
      });
  }

  function clearAllPressed() {
    document
      .querySelectorAll(
        '.' + PRESSED_CLASS
      )
      .forEach(clearPressed);
  }

  function handlePointerDown(event) {
    if (
      event.pointerType === 'mouse'
    ) {
      return;
    }

    var button = findEventButton(
      event.target
    );

    if (!button) return;

    beginTouchPress(
      button,
      event.pointerId
    );
  }

  function handlePointerUp(event) {
    if (
      event.pointerType === 'mouse'
    ) {
      return;
    }

    releasePressedForPointer(
      event.pointerId,
      false
    );
  }

  function handlePointerCancel(event) {
    if (
      event.pointerType === 'mouse'
    ) {
      return;
    }

    releasePressedForPointer(
      event.pointerId,
      true
    );
  }

  /*
   * Fallback for older Safari versions.
   */
  function handleTouchStart(event) {
    var button = findEventButton(
      event.target
    );

    if (!button) return;

    beginTouchPress(
      button,
      'touch'
    );
  }

  function handleTouchEnd() {
    document
      .querySelectorAll(
        '.' + PRESSED_CLASS
      )
      .forEach(function (button) {
        releaseTouchPress(
          button,
          false
        );
      });
  }

  function handleTouchCancel() {
    clearAllPressed();
  }

  function deactivateLoading(button) {
    if (!button) return;

    stopFallback(button);

    button.classList.remove(
      LOADING_CLASS
    );

    button.removeAttribute(
      'aria-busy'
    );

    delete button.dataset
      .magnaearLoadingSource;
  }

  function activateLoading(
    button,
    loadingText,
    source
  ) {
    if (!isEligibleButton(button)) {
      return false;
    }

    prepareButton(button);

    if (
      !ensureLoadingMarkup(
        button,
        loadingText
      )
    ) {
      return false;
    }

    clearPressed(button);
    stopFallback(button);

    button.dataset
      .magnaearLoadingSource =
      source;

    button.setAttribute(
      'aria-busy',
      'true'
    );

    if (
      !button.classList.contains(
        LOADING_CLASS
      )
    ) {
      button.classList.add(
        LOADING_CLASS
      );
    }

    button._magnaearLoadingTimer =
      window.setTimeout(
        function () {
          deactivateLoading(button);
        },
        FALLBACK_DURATION
      );

    return true;
  }

  function syncClassLoading(button) {
    if (!isEligibleButton(button)) {
      return;
    }

    if (
      button.classList.contains(
        'loading'
      )
    ) {
      activateLoading(
        button,
        inferLoadingText(button),
        'class'
      );

      return;
    }

    if (
      button.dataset
        .magnaearLoadingSource ===
      'class'
    ) {
      deactivateLoading(button);
    }
  }

  function findSubmitter(
    event,
    form
  ) {
    if (event.submitter) {
      return event.submitter;
    }

    var active =
      document.activeElement;

    if (
      active &&
      active.form === form
    ) {
      return active;
    }

    return form.querySelector(
      'button[type="submit"], ' +
      'input[type="submit"], ' +
      'button:not([type])'
    );
  }

  /*
   * Continue Checkout after the mobile animation.
   */
  function continueCheckout(
    form,
    button
  ) {
    if (
      !form ||
      !form.isConnected
    ) {
      return;
    }

    form._magnaearCheckoutTimer =
      null;

    form._magnaearCheckoutReleasing =
      true;

    /*
     * requestSubmit keeps name="checkout".
     */
    if (
      typeof form.requestSubmit ===
      'function'
    ) {
      try {
        form.requestSubmit(button);
        return;
      } catch (error) {
        /*
         * Older Safari fallback continues below.
         */
      }
    }

    var checkoutInput =
      document.createElement('input');

    checkoutInput.type = 'hidden';
    checkoutInput.name = 'checkout';
    checkoutInput.value = 'Checkout';

    checkoutInput.setAttribute(
      'data-magnaear-checkout-fallback',
      ''
    );

    form.appendChild(
      checkoutInput
    );

    HTMLFormElement.prototype
      .submit.call(form);
  }

  /*
   * Mobile Checkout waits 700ms so PROCESSING can be displayed.
   */
  function delayMobileCheckout(
    event,
    form,
    button,
    loadingText
  ) {
    if (
      !isTouchLayout() ||
      !isCheckoutButton(button)
    ) {
      return false;
    }

    /*
     * Prevent a second delay and an infinite loop.
     */
    if (
      form
        ._magnaearCheckoutReleasing
    ) {
      return false;
    }

    if (
      !activateLoading(
        button,
        loadingText,
        'checkout-delay'
      )
    ) {
      return false;
    }

    event.preventDefault();

    /*
     * Do not create more than one timer after a double tap.
     */
    if (
      !form._magnaearCheckoutTimer
    ) {
      form._magnaearCheckoutTimer =
        window.setTimeout(
          function () {
            continueCheckout(
              form,
              button
            );
          },
          MOBILE_CHECKOUT_DELAY
        );
    }

    return true;
  }

  function handleNativeSubmit(event) {
    if (
      event.defaultPrevented ||
      !event.target ||
      !event.target.matches('form')
    ) {
      return;
    }

    var form = event.target;

    /*
     * The second submit continues normally.
     */
    if (
      form
        ._magnaearCheckoutReleasing
    ) {
      return;
    }

    var button = findSubmitter(
      event,
      form
    );

    if (!button) return;

    var loadingText =
      inferLoadingText(
        button,
        form
      );

    if (!loadingText) return;

    /*
     * Mobile Checkout receives a short animation delay.
     */
    if (
      delayMobileCheckout(
        event,
        form,
        button,
        loadingText
      )
    ) {
      return;
    }

    /*
     * All other forms continue normally.
     */
    activateLoading(
      button,
      loadingText,
      'native'
    );
  }

  function clearCheckoutDelays() {
    document
      .querySelectorAll('form')
      .forEach(function (form) {
        if (
          form
            ._magnaearCheckoutTimer
        ) {
          window.clearTimeout(
            form
              ._magnaearCheckoutTimer
          );
        }

        form
          ._magnaearCheckoutTimer =
          null;

        delete form
          ._magnaearCheckoutReleasing;

        form
          .querySelectorAll(
            '[data-magnaear-checkout-fallback]'
          )
          .forEach(
            function (input) {
              input.remove();
            }
          );
      });
  }

  function clearLoadingStates() {
    document
      .querySelectorAll(
        '.' + LOADING_CLASS
      )
      .forEach(deactivateLoading);

    clearAllPressed();
    clearCheckoutDelays();
  }

  function init() {
    prepareTree(document.body);

    document.addEventListener(
      'submit',
      handleNativeSubmit
    );

    window.addEventListener(
      'pageshow',
      clearLoadingStates
    );

    /*
     * Modern iPhone, iPad and Android browsers.
     */
    if ('PointerEvent' in window) {
      document.addEventListener(
        'pointerdown',
        handlePointerDown,
        true
      );

      document.addEventListener(
        'pointerup',
        handlePointerUp,
        true
      );

      document.addEventListener(
        'pointercancel',
        handlePointerCancel,
        true
      );
    } else {
      /*
       * Older Safari fallback.
       */
      document.addEventListener(
        'touchstart',
        handleTouchStart,
        {
          capture: true,
          passive: true,
        }
      );

      document.addEventListener(
        'touchend',
        handleTouchEnd,
        {
          capture: true,
          passive: true,
        }
      );

      document.addEventListener(
        'touchcancel',
        handleTouchCancel,
        {
          capture: true,
          passive: true,
        }
      );
    }

    document.addEventListener(
      'shopify:section:load',
      function (event) {
        prepareTree(event.target);
      }
    );

    /*
     * Watch dynamically rendered Shopify buttons.
     */
    var observer =
      new MutationObserver(
        function (mutations) {
          mutations.forEach(
            function (mutation) {
              if (
                mutation.type ===
                'attributes'
              ) {
                prepareButton(
                  mutation.target
                );

                syncClassLoading(
                  mutation.target
                );

                return;
              }

              mutation.addedNodes
                .forEach(prepareTree);
            }
          );
        }
      );

    observer.observe(
      document.body,
      {
        attributes: true,
        attributeFilter: [
          'class',
        ],
        childList: true,
        subtree: true,
      }
    );

    document
      .querySelectorAll(
        BUTTON_SELECTOR + '.loading'
      )
      .forEach(syncClassLoading);
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true,
      }
    );
  } else {
    init();
  }
})();